export default __webpack_public_path__ + "static/1199-39e444040d2499e95c059de55c626a0b.gif";